import { apiClient } from './api.js';

class EnumService {
  getOfficialDocumentTypes() {
    return apiClient.get('/Enum/OfficialDocumentTypes');
  }
}

export default new EnumService();
